<template>
  <div class="edit-password">
    <van-nav-bar :title="lang.changePassword" :left-arrow="!$route.query.fromapp" @click-left="$router.go(-1)" />

    <div v-if="!isSuccess">
      <div class="main">
        <div class="input-model">
          <input :type="showPsdIcon1 ? 'text' : 'password'" v-model="oldpsd" :placeholder="lang.oldPassword" />
          <svg class="icon show-psd" aria-hidden="true" @click="showPsdIcon1 = !showPsdIcon1">
            <use :xlink:href="showPsdIcon1 ? '#icon-xianshimima' : '#icon-yincangmima'"></use>
          </svg>
        </div>
        <div class="input-model">
          <input :type="showPsdIcon2 ? 'text' : 'password'" v-model="newpsd" :placeholder="lang.newPassword" />
          <svg class="icon show-psd" aria-hidden="true" @click="showPsdIcon2 = !showPsdIcon2">
            <use :xlink:href="showPsdIcon2 ? '#icon-xianshimima' : '#icon-yincangmima'"></use>
          </svg>
        </div>
        <div class="input-model">
          <input :type="showPsdIcon3 ? 'text' : 'password'" v-model="renewpsd" :placeholder="lang.reNewPassword" />
          <svg class="icon show-psd" aria-hidden="true" @click="showPsdIcon3 = !showPsdIcon3">
            <use :xlink:href="showPsdIcon3 ? '#icon-xianshimima' : '#icon-yincangmima'"></use>
          </svg>
        </div>
        <!-- 更换添加 显示密码 -->
        <!-- <input type="password" v-model="oldpsd" :placeholder="lang.oldPassword" />
        <input type="password" v-model="newpsd" :placeholder="lang.newPassword" />
        <input type="password" v-model="renewpsd" :placeholder="lang.reNewPassword" /> -->
      </div>
      <div class="btn-sub">
        <van-button @click="clickEdit" :disabled="oldpsd && newpsd && renewpsd ? false : true" type="danger" size="large">{{ lang.confirm1 }}</van-button>
        <p @click="$router.push('/forget/')">{{ lang.forgetPassword }}</p>
      </div>
    </div>
    <div v-else class="success">
      <p>
        <span><van-icon name="success"/></span> {{ lang.editSuccess }}
      </p>
      <van-button type="danger" @click="goLogin" size="large">{{ lang.login }} ({{ second }})</van-button>
    </div>
  </div>
</template>
<script>
import lang from './../../../common/language/editUser';
export default {
  data() {
    return {
      lang: lang,
      timeId: '',
      second: 5,
      isSuccess: false,
      oldpsd: '',
      newpsd: '',
      renewpsd: '',
      showPsdIcon1: false,
      showPsdIcon2: false,
      showPsdIcon3: false
    };
  },
  methods: {
    goLogin() {
      this.pub.delCookie('ERnJaMWtkM');
      this.pub.delCookie('cEVaUDFrZ1kd0RA');
      if (navigator.userAgent.indexOf('house730') > -1) {
        let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1; //android终端
        const isFlutter = navigator.userAgent.indexOf('flutter') > -1;
        if (isFlutter) {
          window.house730.postMessage(JSON.stringify({ type: 'jumpLogin', data: {} }));
        } else if (isAndroid) {
          window.house730.jumpLogin();
        } else {
          window.webkit.messageHandlers.jumpLogin.postMessage(JSON.stringify({}));
        }
      } else {
        this.$router.push('/login/?tab=1');
      }
    },
    /**点击修改密码 */
    clickEdit() {
      if (this.newpsd !== this.renewpsd) {
        this.$notify(lang.newPsdError);
        return;
      } else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(this.newpsd)) {
        this.$notify(lang.psdError);
        return;
      } else {
        this.axios
          .post(this.pub.getApi().UpdateUserPassword, {
            oldPassword: this.oldpsd,
            newPassword: this.newpsd
          })
          .then(res => {
            if (res.data.code == 1302) {
              this.$notify(lang.oldPsdError);
            } else if (res.data.code == 0) {
              /**修改成功 */
              this.isSuccess = true;
              this.timeId = setInterval(() => {
                this.second--;
                if (this.second <= 0) {
                  clearInterval(this.timeId);
                  /**退出登录 */
                  this.goLogin();
                }
              }, 1000);
            }
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.edit-password {
  .main {
    padding: 33px 26px;
    overflow: hidden;
    input {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline: none;
      border: none;
      padding: 0 2px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .input-model {
      position: relative;
      border-bottom: 1px solid #eee;
      input {
        padding-right: 30px;
      }
      .show-psd {
        position: absolute;
        top: 12px;
        right: 4px;
        font-size: 24px;
      }
    }
  }
  .btn-sub {
    padding: 0 26px;
    p {
      line-height: 50px;
      color: #b2b2b2;
      font-size: 14px;
    }
  }
  .success {
    p {
      font-size: 20px;
      line-height: 48px;
      color: #333;
      padding: 50px 0 37px 0;
      span {
        margin-right: 6px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: #4cd964;
        display: inline-block;
        vertical-align: middle;
        .van-icon-success {
          color: #fff;
          font-size: 26px;
          line-height: 48px;
        }
      }
    }
    padding: 0 26px;
  }
}
</style>
